/**
 * List of all supported trading pairs
 * Client-side: Load 100% từ API /api/symbols
 *
 * QUAN TRỌNG: Danh sách symbols được lấy từ database qua API
 * Không có fallback hardcode - buộc phải load từ API
 */

import api from '../config/api';

// Cache để tránh gọi API liên tục
let cachedSymbols = null;
let cacheExpiry = 0;
const CACHE_DURATION = 60000; // 60 giây

/**
 * Lấy danh sách symbols từ API (có cache)
 * Không có fallback - buộc phải load từ API/DB
 */
export async function getAllTradingPairs() {
  const now = Date.now();

  // Kiểm tra cache
  if (cachedSymbols && now < cacheExpiry) {
    return cachedSymbols;
  }

  // Lấy từ API
  const response = await api.get('/api/symbols/names');
  if (response.data.success && Array.isArray(response.data.data)) {
    cachedSymbols = response.data.data;
    cacheExpiry = now + CACHE_DURATION;
    return cachedSymbols;
  }

  // Nếu API lỗi, ném exception
  throw new Error('Cannot load symbols from API');
}

/**
 * Xóa cache (dùng khi cần refresh)
 */
export function clearSymbolCache() {
  cachedSymbols = null;
  cacheExpiry = 0;
}

// Export default
export default {
  getAllTradingPairs,
  clearSymbolCache
};
